import { FlexRow, FlexColumn } from '@editor/components/utilities/layouts';
import { ScrollableArea } from '@repo/ui-kit/components/core/ScrollableArea';
import { themeStyle } from '@repo/ui-kit/themeStyle';
import styled from 'styled-components';

export const DialogTitle = styled(FlexRow)`
  padding: ${themeStyle.spacing16} ${themeStyle.spacing24};
  border-bottom: 1px solid ${themeStyle.colorBgFillSecondary};
`;

export const WorkspaceList = styled(ScrollableArea)`
  max-height: 300px;
  padding: 0px ${themeStyle.spacing24} ${themeStyle.spacing16}
    ${themeStyle.spacing24};
`;

export const WorkspaceItem = styled(FlexRow)`
  padding: ${themeStyle.spacing8} 0px;
  align-items: center;
  justify-content: space-between;
  border-radius: ${themeStyle.borderRadius8};
`;

export const WorkspaceItemDetails = styled(FlexRow)`
  gap: ${themeStyle.spacing12};
  align-items: center;
`;

export const WorkspaceInfo = styled(FlexColumn)`
  gap: ${themeStyle.spacing4};
  max-width: 100px;
`;

export const MemberCountWrapper = styled(FlexRow)`
  align-items: center;
  gap: ${themeStyle.spacing8};
  height: ${themeStyle.spacing16};
`;
